Object.defineProperty(exports,"__esModule",{value:true});var _createStrictShapeTypeChecker=require('./createStrictShapeTypeChecker');var _createStrictShapeTypeChecker2=_interopRequireDefault(_createStrictShapeTypeChecker);var _propTypes=require('prop-types');function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var PointPropType=(0,_createStrictShapeTypeChecker2.default)({x:_propTypes.number,y:_propTypes.number});exports.default=PointPropType;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-native-web/dist/propTypes/PointPropType.js
 ** module id = 866
 ** module chunks = 0
 **/